import React from 'react';
import { Typography } from '@/components/Atoms';
import classNames from 'classnames';
import styles from './LeaderBoardSection.module.scss'; // Import your styles
import first from '@/public/images/commandCenter/first.png';
import second from '@/public/images/commandCenter/second.png';
import third from '@/public/images/commandCenter/third.png';
import shape1st from '@/public/images/commandCenter/firstRank.png';
import shape2nd from '@/public/images/commandCenter/secondRank.png';
import shape3rd from '@/public/images/commandCenter/thirdRank.png';
import XpImage from '@/public/images/commandCenter/xp.png';
import Image, { StaticImageData } from 'next/image';

const TopItem = (props: {
  badgeImg: string;
  shapeStyle: string;
  name: string;
  reward: string;
  rankImg: StaticImageData;
  overlayStyles: string;
  shapeImg: StaticImageData;
  bold?: boolean;
  glow?: string;
  rewardType: 'LRT' | 'XP';
}) => {
  return (
    <div
      className={classNames(
        'relative pt-12 sm:w-[170px] w-[100px]',
        props.bold && 'scale-105 transform -translate-y-2 drop-shadow-[0px_4px_20px_#BC9032] z-10 -mx-1',
      )}
    >
      <div className='absolute sm:top-4 top-7 left-1/2 z-10 transform -translate-x-1/2 sm:w-16 sm:h-16 w-10 h-10'>
        <Image src={props.rankImg} alt='second' layout='fill' objectFit='contain' />
      </div>
      <div className={classNames('w-full aspect-[188/313] relative', props.shapeStyle)}>
        <Image src={props.shapeImg} alt='shape image' layout='fill' />
        <div className={classNames(styles.overlayShape, props.overlayStyles)}></div>
        <div className='relative flex flex-col items-center px-5'>
          {/* Badge */}
          <div className='aspect-[97/80] sm:w-24 w-16 relative sm:mt-6 mt-4 z-20'>
            <Image src={props.badgeImg} objectFit='contain' layout='fill' alt='badge-image' />
          </div>
          <Typography size='s16ToS12' className='text-white text-center sm:mt-2 mt-1 line-clamp-1 break-all'>
            {props.name}
          </Typography>
          <div className='flex items-center sm:mt-16 mt-6 gap-1'>
            {props.rewardType === 'LRT' && <img className='sm:w-4 sm:h-4 w-3 h-3 object-contain' src={'/images/brands/lrt.svg'} alt='LRT' />}
            {props.rewardType === 'XP' && (
              <div className='sm:w-7 sm:h-7 w-5 h-5 relative'>
                <Image className='object-contain' src={XpImage} alt='XP' />
              </div>
            )}
            <Typography size='s16ToS12' className='text-white text-center'>
              {props.reward}
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

const ItemBoxAssetLeaderboard = (props: {
  lastCol?: string;
  list: Array<{
    username: string;
    value: string;
    position: number;
    level: string;
    badgeImg: string;
    rewardType: 'LRT' | 'XP';
  }>;
  isRecent?: boolean;
  myRankData?: any;
}) => {
  const { lastCol = 'Value', list, isRecent, myRankData } = props;

  const topThree = list.slice(0, 3);
  const restOfList = list.slice(3);

  return (
    <div className='relative h-full flex flex-col'>
      {list?.length > 0 ? (
        <>
          {/* Header Section - Top 3 */}
          {!isRecent && (
            <div className='flex mb-10 flex-row w-full justify-center items-center relative'>
              {/* Shape 1 - Second place */}
              {topThree?.[1] && (
                <TopItem
                  badgeImg={topThree[1]?.badgeImg}
                  name={topThree[1]?.username}
                  reward={topThree[1]?.value}
                  rankImg={second}
                  // shapeStyle={styles.shape1}
                  shapeStyle={''}
                  overlayStyles={styles.overlaySilver}
                  shapeImg={shape2nd}
                  rewardType={topThree[1]?.rewardType}
                />
              )}

              {/* Shape 2 - First place */}
              {topThree?.[0] && (
                <TopItem
                  badgeImg={topThree[0]?.badgeImg}
                  name={topThree[0]?.username}
                  reward={topThree[0]?.value}
                  rankImg={first}
                  // shapeStyle={styles.shape2}
                  shapeStyle={''}
                  overlayStyles={styles.overlayGold}
                  shapeImg={shape1st}
                  rewardType={topThree[0]?.rewardType}
                  bold
                />
              )}

              {/* Shape 3 - Third place */}
              {topThree?.[2] && (
                <TopItem
                  badgeImg={topThree[2]?.badgeImg}
                  name={topThree[2]?.username}
                  reward={topThree[2]?.value}
                  rankImg={third}
                  // shapeStyle={styles.shape3}
                  shapeStyle={''}
                  overlayStyles={styles.overlayBronze}
                  shapeImg={shape3rd}
                  rewardType={topThree[2]?.rewardType}
                />
              )}
              {/* <div className={classNames(styles.shape, styles.shape3, 'relative')}>
                <div className='absolute top-[-30%] left-1/2 transform -translate-x-1/2 w-16 h-16'>
                  <Image src={third} alt='third' layout='fill' objectFit='contain' />
                </div>
                <div className={classNames(styles.overlayShape, styles.overlayBronze)}></div>
                <Typography className='text-white text-center mt-4'>{topThree[2]?.username}</Typography>
                <Typography className='text-white text-center'>{topThree[2]?.value}</Typography>
              </div> */}
            </div>
          )}

          {/* Scrollable List Section */}
          <div className='flex-1 overflow-y-auto my-2 mt-2 space-y-2 boxItems'>
            {/* Show the rest of the list, starting from 4th place */}
            {!isRecent &&
              restOfList?.map(({ username, value, level, badgeImg, position, rewardType }) => (
                <div
                  key={position}
                  className={classNames(
                    'flex flex-row bg-[#1A2F36] rounded-lg h-12 items-center px-2',
                    myRankData && myRankData?.position === position && 'border border-[#FBCE00]',
                  )}
                >
                  {/* Position */}
                  <Typography size='s16ToS12' className='text-white font-bold w-6 flex justify-center'>
                    {position}
                  </Typography>
                  <div className='w-[1px] h-10 bg-[#717171] my-2 mx-2'></div>
                  {/* Data Columns */}
                  <div className='flex flex-row justify-between w-full'>
                    {/* Username */}
                    <div className='flex flex-row items-center w-2/4 gap-1'>
                      <div className='relative aspect-square sm:w-8 w-6'>
                        <Image layout='fill' src={badgeImg} alt='badge' className='object-contain' />
                      </div>
                      <Typography size='s16ToS12' className='text-white truncate'>
                        {username}
                      </Typography>
                    </div>
                    {/* Level */}
                    <Typography size='s16ToS12' className='text-white w-1/4 text-start'>
                      Level: {level}
                    </Typography>
                    {/* Value */}
                    <div className='flex items-center gap-1 w-1/4'>
                      {rewardType === 'LRT' && <img className='aspect-square sm:w-4 w-3.5 object-contain' src={'/images/brands/lrt.svg'} alt='LRT' />}
                      {rewardType === 'XP' && (
                        <div className='aspect-square sm:w-7 w-5 relative'>
                          <Image className='object-contain' src={XpImage} alt='XP' />
                        </div>
                      )}
                      <Typography size='s16ToS12' className='text-white text-center'>
                        {value}
                      </Typography>
                    </div>
                  </div>
                </div>
              ))}

            {/* When isRecent is true, show the full list */}
            {isRecent &&
              list?.map(({ username, value, level, position }) => (
                <div key={position} className='flex flex-row bg-[#1A2F36] rounded-lg h-12 items-center px-2'>
                  {/* Position */}
                  <Typography size='s16ToS12' className='text-white font-bold w-6 flex justify-center'>
                    {position}
                  </Typography>
                  <div className='w-[1px] h-10 bg-[#717171] my-2 mx-2'></div>
                  {/* Data Columns */}
                  <div className='flex flex-row justify-between w-full'>
                    <Typography size='s16ToS14' className='text-white w-2/3 truncate'>
                      {username}
                    </Typography>
                  </div>
                </div>
              ))}
          </div>

          {/* Sticky Footer */}
          {!isRecent && (
            <div className='flex gap-2 bg-[#20232B] border rounded-md border-[#0C917D] py-2 mt-2 sticky bottom-0 z-10'>
              <Typography className='ps-2 text-[#0C917D] font-bold truncate'>Your rank:</Typography>
              <Typography className='text-[#0C917D] font-bold line-clamp-1'>{myRankData ? myRankData?.position : 'No rank yet'}</Typography>
            </div>
          )}
        </>
      ) : (
        <Typography Component={'p'} className='text-white text-center pt-4 w-full font-bold'>
          There are no available data.
        </Typography>
      )}
    </div>
  );
};

export default ItemBoxAssetLeaderboard;
